import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { Location } from '@/types/types';

export const useCreateLocation = (projectId: number) => {
  const { axiosInstance } = useApi();
  const queryClient = useQueryClient();
  return useMutation<Location, unknown, { name: string }>({
    mutationFn: async ({ name }) => {
      const { data } = await axiosInstance.post(`/api/v1/projects/${projectId}/locations`, {
        location: { name },
      });
      return data as Location;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.locations.list(projectId).queryKey });
    },
  });
};

export default useCreateLocation;
